import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { GlobalHttpInterceptor } from './interceptors';
import { AuthHttpInterceptor, AuthModule } from '@auth0/auth0-angular';

import { EnsureModuleLoadedOnceGuard } from '@core/guards';
import { environment } from '@environments/environment';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http);
}

const auth0_audience = 'Tyx_AutomatedGenotyping_AdminApi';
const auth0_cacheLocation = 'localstorage';

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        AuthModule.forRoot({
            domain: environment.auth0.domain,
            clientId: environment.auth0.clientId,
            cacheLocation: auth0_cacheLocation,
            authorizationParams: {
                redirect_uri: environment.auth0.redirectUri + '',
                audience: auth0_audience,
            },
            httpInterceptor: {
                allowedList: [
                    {
                        uri: `${environment.apiUrl}/*`,
                        tokenOptions: {
                            authorizationParams: {
                                audience: auth0_audience,
                            },
                        },
                    },
                ],
            },
        }),
        TranslateModule.forRoot({
            defaultLanguage: 'en',
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
    ],
    exports: [TranslateModule],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthHttpInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: GlobalHttpInterceptor,
            multi: true,
        },
    ],
})
export class CoreModule extends EnsureModuleLoadedOnceGuard {
    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        super(parentModule);
    }
}
